export function createBackgroundChecker({ timeout = 2, callback }) {
  let intervalId = null;

  const start = () => {
    if (intervalId !== null) return;
    callback();
    intervalId = setInterval(callback, timeout * 60 * 1000);
  };

  const stop = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  return { start, stop };
}
